const itemCount = {
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: 'normal'
}

const title = {
  fontSize: '24px',
  lineHeight: '30px',
  fontWeight: '400',
  textTransform: 'uppercase',
  'screen-medium': {
    fontSize: '28px',
    lineHeight: '35px'
  }
}

const loyaltyProductsGrid = {
  itemCount,
  title
}

export default loyaltyProductsGrid
